import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux";
import { fetchTestNotifications, dismissTestNotification } from "../redux/reducers/testNotificationsSlice";
import { View, Card, Text } from "./base";
import { Spinner } from "./base/Spinner";
import { Icon } from "./base/Icon";

interface TestNotificationsProps {
  agentId: string;
  onTestSelect: (testName: string) => void;
}

export const TestNotifications: React.FC<TestNotificationsProps> = ({ agentId, onTestSelect }) => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((state) => (state.testNotifications as any).notifications[agentId] || []);
  const isLoading = useAppSelector((state) => (state.testNotifications as any).isLoading[agentId] || false);
  const error = useAppSelector((state) => (state.testNotifications as any).error[agentId]);

  // TODO: Uncomment this when we have a better way to fetch notifications
  // useEffect(() => {
  //   if (agentId) {
  //     dispatch(fetchTestNotifications(agentId));
  //   }
  // }, [agentId, dispatch]);

  const handleNotificationClick = async (testName: string) => {
    try {
      await dispatch(dismissTestNotification({ agentId, testName })).unwrap();

      // Select the test
      onTestSelect(testName);
    } catch (error) {
      console.error("Failed to dismiss notification:", error);
    }
  };

  if (isLoading) {
    return (
      <View className="flex justify-center py-4">
        <Spinner
          size={24}
          variant="brand"
        />
      </View>
    );
  }

  if (error) {
    return null; // Don't show anything if there's an error
  }

  if (notifications.length === 0) {
    return null; // Don't show anything if there are no notifications
  }

  return (
    <View className="mb-6">
      <View className="mb-2">
        <Text className="text-lg font-semibold">Notifications</Text>
      </View>
      <View className="space-y-3">
        {notifications.map((testName: string, index: number) => (
          <View
            key={`${testName}-${index}`}
            className="cursor-pointer"
            onClick={() => handleNotificationClick(testName)}
          >
            <Card className="border-2 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-600 hover:bg-yellow-100 dark:hover:bg-yellow-900/30 transition-colors">
              <View className="p-3">
                <Icon
                  name="notification"
                  className="w-4 h-4 text-yellow-800 dark:text-yellow-200 mr-2"
                />
                <Text className="text-yellow-800 dark:text-yellow-200 font-medium">
                  <span className="font-semibold">Test Complete:</span> Test <span className="font-bold">{testName}</span> has finished
                </Text>
              </View>
            </Card>
          </View>
        ))}
      </View>
    </View>
  );
};
